import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectiveModule } from '@app/directives/directive.module';
import { CookieComponent } from './cookie.component';
import { AngularMaterialModule } from '../../material.module';

@NgModule({
  declarations: [CookieComponent],
  imports: [CommonModule, DirectiveModule, AngularMaterialModule],

  exports: [CookieComponent],

  providers: [],
})
export class CookieModule {}
